import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { isViewingSoftCreditRatingForm } from "src/store/actions/onlineShopper";
import { updateAnnualEstimatedIncome } from "src/store/actions/userInfo";
import { patchDealPerson } from "src/store/dataService/actions/deal";
import { getVehiclesArrayForFEA } from "src/store/selectors/vehicles";
import { Deal } from "Types/api/Deal";
import { FormState } from "../CreditRatingForm/CreditRatingForm";
import CreditRatingStepWizard from "./CreditRatingStepWizard";

function mapStateToProps(state: ApplicationStore) {
    const { deal, onlineShopper } = state;
    let initialFormData: Partial<FormState> = {};
    if (deal && deal.person) {
        initialFormData = {
            address: deal.person.street1,
            city: deal.person.city,
            email: deal.person.email,
            firstName: deal.person.first_name,
            lastName: deal.person.last_name,
            postal: deal.person.zip,
            state: deal.person.state,
        };
    }
    return {
        initialFormData,
        uuid: deal.uuid as string,
        vehicles: getVehiclesArrayForFEA(state),
        isViewingSoftCreditRatingForm: onlineShopper.isViewingSoftCreditRatingForm,
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    patchDealPerson: (uuid: string, data: Deal["person"]) => dispatch(patchDealPerson(uuid, data)),
    setIsViewingSoftCreditRatingForm: (isViewing: boolean) =>
        dispatch(isViewingSoftCreditRatingForm.setIsViewingSCPForm(isViewing)),
    updateAnnualEstimatedIncome: (income: number) => dispatch(updateAnnualEstimatedIncome(income)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditRatingStepWizard);
